import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectionsService } from '../../../services/connectionsWeb3/connections.service';
import { AuthService } from '../../../services/auth.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Subject, of } from 'rxjs';
import { takeUntil, switchMap, catchError, filter } from 'rxjs/operators';

@Component({
  selector: 'app-wallet-connect-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './wallet-connect-button.component.html',
  styleUrls: ['./wallet-connect-button.component.css']
})
export class WalletConnectButtonComponent implements OnInit, OnDestroy {
  addressUser: string = '';
  addressUserTruncate: string = '';
  hideBlockchain: boolean = true;
  isLoading: boolean = true;
  private destroy$ = new Subject<void>();

  constructor(
    private connectionsService: ConnectionsService,
    private authService: AuthService,
    private afs: AngularFirestore
  ) {}

  ngOnInit(): void {
    // Escuchar el estado de autenticación y determinar hideBlockchain con un solo flujo
    this.authService.userAuth
      .pipe(
        takeUntil(this.destroy$),
        filter(user => !!user),
        switchMap((user: any) => 
          this.afs.collection('users').doc(user.uid).valueChanges()
        ),
        catchError(error => {
          console.error("Error obteniendo usuario para hideBlockchain:", error);
          this.isLoading = false;
          return of(null);
        })
      )
      .subscribe((userData: any) => {
        if (userData) {
          this.hideBlockchain = userData.hideBlockchain;
          // Iniciar subscripción a web3 state solo si formamos parte del blockchain module
          if (!this.hideBlockchain) {
            // Se suscribe a la wallet local
             this.connectionsService.addressUser
               .pipe(takeUntil(this.destroy$))
               .subscribe((addr: string) => {
                 this.addressUser = addr;
                 this.addressUserTruncate = addr ? `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}` : '';
                 this.isLoading = false;
               });
               
            // Intentar autoconectar tras renderizar
            this.tryAutoConnect();
          } else {
             this.isLoading = false;
          }
        }
      });
  }

  async tryAutoConnect(): Promise<void> {
    if (typeof (window as any).ethereum !== 'undefined' && !this.hideBlockchain) {
      try {
        const isUnlocked = await (window as any).ethereum?._metamask?.isUnlocked();
        if (isUnlocked) {
           await this.connectionsService.autoConnect();
        }
      } catch (err) {
        console.warn('Error durante autoConnect silenciado', err);
      }
    }
  }

  connect(): void {
    this.connectionsService.connect();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
